import pick from 'lodash/pick';
import { paginationFields } from '@/models/pagination.model';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getSuggestedFaqs } from './actionCreators';
import { SuggestedFaqState, SLICE_NAME, initialState } from './models';

export const suggestedFaqSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSuggestedFaqs.fulfilled, (state: SuggestedFaqState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.suggestions = payload.suggestions;
        state.pagination = pick(payload, paginationFields);
      })
      .addMatcher(isPending(getSuggestedFaqs), (state: SuggestedFaqState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getSuggestedFaqs), (state: SuggestedFaqState, action) => {
        const { error } = action;

        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
